/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable import/no-namespace */
/* eslint-disable import/exports-last */
import React, { useCallback, useEffect, useState } from 'react'
import { OverlaySpinner } from '@usap/widgets'
import ButtonDifmWmo from './Wmo/ButtonDifmWmo'
import VehicleSelectorWmo, { VehiclePropertyField, VehicleWmo } from '../../vsComponent/VehicleSelectorWmo'
import { ICartItemProduct } from '../models/ICart'
import useUpdateVehicle from '../../ShoppingCartV2/components/Items/Item/VehicleFitment/hooks/useUpdateVehicle'
import { toVehicleContext } from '../models/DifmVehicle'

import * as Styled from './InstallAtShopNoVehicleWmo.css'

export interface IInstallAtShopInfoWmo {
  product?: ICartItemProduct
}
const spinnerStyle = { left: 0, top: 0 }
const InstallAtShopNoVehicleCartWmo: React.FC<IInstallAtShopInfoWmo> = ({ product }) => {
  const [showSpinner, shouldShowSpinner] = useState(false)
  const [cartVehicleDB, setCartVehicleDB] = useState({} as any)

  const updateVehicle = useCallback(() => {
    useUpdateVehicle({
      cartVehicleDB,
      product,
      shouldShowSpinner,
    })()
  }, [cartVehicleDB, product, shouldShowSpinner])

  const onAddVehicle = useCallback(
    (vehicle: VehicleWmo) => {
      const updatedVehicle: any = toVehicleContext(vehicle)
      updatedVehicle.itemId = product?.productId
      setCartVehicleDB(updatedVehicle)
    },
    [product],
  )

  useEffect(() => {
    if (cartVehicleDB?.year) {
      updateVehicle()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartVehicleDB])

  return (
    <>
      <Styled.NoVehicleContainer data-testid="install-at-shop-no-vehicle">
        <Styled.ShopTitle>
          Install at Shop
        </Styled.ShopTitle>

        <Styled.ShopMessage>
          Tell us what you drive and one of our certified shops can get it done for you.
        </Styled.ShopMessage>

        <VehicleSelectorWmo
          componentType="dialog"
          button={<ButtonDifmWmo label="Add Vehicle" dataTestId="add-vehicle-cta" />}
          onVehiclePropertyChange={(property: VehiclePropertyField, value: string) => console.log(`VS MFE: Updating ${property} value to be ${value}`)}
          onAddVehicle={onAddVehicle}
        />
        <OverlaySpinner active={showSpinner} style={spinnerStyle} centered width={50} height={50} zIndex={10} />
      </Styled.NoVehicleContainer>
    </>
  )
}

export default React.memo(InstallAtShopNoVehicleCartWmo)
